import styled from '@emotion/styled';
import { IconButton, TextField } from '@mui/material';
import { DynamicIcon } from 'src/components';

// ClearIconButton is a Styled component wrapper to make possibility reference from another Styled Object.
const ClearIconButton = styled(IconButton)();

const SearchIconButton = styled(IconButton)({
  margin: '0 0.5rem',
});

const SearchField = styled(TextField)((props) => ({
  width: !props.value ? '2rem' : undefined,
  '&:focus-within': {
    width: 'initial',
  },
  '.MuiInput-root:hover:not(:focus-within):not(.Mui-disabled, .Mui-error):before, .MuiInput-root:not(:focus-within):before':
    {
      borderBottom: !props.value ? 'none' : undefined,
    },
  [ClearIconButton.toString()]: {
    visibility: 'hidden',
  },
  '&:hover': {
    [ClearIconButton.toString()]: {
      visibility: !props.value ? 'hidden' : 'visible',
    },
    [SearchIconButton.toString()]: {
      cursor: !props.value ? 'pointer' : 'auto',
    },
  },
}));

export interface UsersSearchInputProps {
  value: string;
  onChange: (value: string) => void;
}

export const UsersSearchInput = ({ value, onChange }: UsersSearchInputProps) => {
  return (
    <SearchField
      variant="standard"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder="Filter users"
      InputProps={{
        startAdornment: (
          <SearchIconButton>
            <DynamicIcon name="search" library="lucide" />
          </SearchIconButton>
        ),
        endAdornment: (
          <ClearIconButton size="small" onClick={() => onChange('')}>
            <DynamicIcon name="x" library="lucide" />
          </ClearIconButton>
        ),
        disableUnderline: false,
      }}
    />
  );
};
